export default __webpack_public_path__ + "static/media/eye_close.6e8c116f.svg";